// extracted by mini-css-extract-plugin
export default {"iconInfo":"IconInfo_iconInfo__XM6An"};